import React from 'react'
import PropTypes from 'prop-types'
import styles from './Spacer.module.scss'

const Spacer = props => {
    return (
        <div className={props.border ? styles.borderedSpacer : styles.spacer}></div>
    )
}

Spacer.propTypes = {
    border: PropTypes.bool
}

export default Spacer
